import React from 'react';
import { ProductModuleEmbedConfigSupportType } from 'site-config';
import { useSiteConfigContext } from 'style-context';
import { Alert } from '../alerts/alert';
import { UsePromiseError } from 'shared/hooks/promise';
import { sentenceCase } from 'sentence-case';

export const ErrorAlert = (params: { error: Error | undefined; title?: string; displayFieldError?: boolean }) => {
  const { siteConfig } = useSiteConfigContext();
  const supportType = siteConfig?.settings.supportType;

  let supportLinkText = '';
  let supportLink: string | undefined;

  switch (supportType) {
    case ProductModuleEmbedConfigSupportType.Email:
      supportLinkText = siteConfig?.settings.supportEmail ?? '';
      supportLink = siteConfig?.settings.supportEmail ? `mailto:${siteConfig.settings.supportEmail}` : '';
      break;

    case ProductModuleEmbedConfigSupportType.Url:
      supportLinkText = siteConfig?.settings.supportUrl?.label ?? '';
      supportLink = siteConfig?.settings.supportUrl?.url ?? '';
      break;

    case ProductModuleEmbedConfigSupportType.Phone:
      supportLinkText = siteConfig?.settings.supportContactNumber?.label ?? '';
      supportLink = siteConfig?.settings.supportContactNumber
        ? `tel:${siteConfig.settings.supportContactNumber.number}`
        : '';
      break;

    case ProductModuleEmbedConfigSupportType.OverrideMessage:
      supportLinkText = siteConfig?.settings.overrideSupportMessage ?? '';
      break;

    default:
      supportLinkText = '';
      supportLink = '';
  }

  const { error, title } = params;
  const displayFieldError = params.displayFieldError === true;

  if (!error) {
    return <></>;
  }

  return (
    <Alert
      variant='danger'
      title={title || 'Error'}
      body={
        <>
          <p>{getErrorMessage({ displayFieldError, error })}</p>
          {supportType === ProductModuleEmbedConfigSupportType.OverrideMessage && (
            <p>{siteConfig?.settings.overrideSupportMessage}</p>
          )}
          {supportType !== ProductModuleEmbedConfigSupportType.OverrideMessage && (
            <p>
              {`Please try again or ${supportType === ProductModuleEmbedConfigSupportType.Url ? 'visit' : 'contact'}`}
              &nbsp;
              <a href={supportLink} target='_blank' rel='noreferrer'>
                {supportLinkText}
              </a>
              &nbsp;if the problem persists.
            </p>
          )}
        </>
      }
    />
  );
};

const getErrorMessage = (params: { displayFieldError: boolean; error: UsePromiseError }) => {
  const { displayFieldError, error } = params;

  if (displayFieldError && error.fieldErrors && error.fieldErrors.length > 0) {
    // eslint-disable-next-line no-useless-escape
    const path = error.fieldErrors[0].path.replace(/[_\.]/g, ' ');
    const { message } = error.fieldErrors[0];
    // eslint-disable-next-line no-useless-escape
    const cleanedMessage = message.replace(/\".*?\"/g, '');

    return sentenceCase(`${path} ${cleanedMessage}`);
  }
  return error.message;
};
